import { render, staticRenderFns } from "./resultCoin.vue?vue&type=template&id=ef59bd60&scoped=true"
import script from "./resultCoin.vue?vue&type=script&lang=js"
export * from "./resultCoin.vue?vue&type=script&lang=js"
import style0 from "./resultCoin.vue?vue&type=style&index=0&id=ef59bd60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef59bd60",
  null
  
)

export default component.exports